// Photo of the person to serve — supplied by the client when ordering.
// It travels with the order's documents (same private bucket, same staging and
// promotion path) but it is NOT a court paper: it is never page-counted for the
// large-packet fee, never sent to the document reader, and never used to pick
// a Proof of Service form. One shared definition so every path agrees.
var SUBJECT_PHOTO = "subject_photo";
var MAX_SUBJECT_PHOTOS = 3;
var PHOTO_EXT = ["jpg", "jpeg", "png", "heic"];   // subset of the bucket allowlist (uploadLimits)

function isSubjectPhoto(d) {
  return !!(d && d.role === SUBJECT_PHOTO);
}
function courtDocs(docs) {
  return (Array.isArray(docs) ? docs : []).filter(function (d) { return !isSubjectPhoto(d); });
}
function subjectPhotos(docs) {
  return (Array.isArray(docs) ? docs : []).filter(isSubjectPhoto);
}
function isPhotoFile(name, mimeType) {
  var n = String(name || "").toLowerCase();
  var ext = n.indexOf(".") >= 0 ? n.slice(n.lastIndexOf(".") + 1) : "";
  return String(mimeType || "").indexOf("image/") === 0 || PHOTO_EXT.indexOf(ext) >= 0;
}

module.exports = { SUBJECT_PHOTO: SUBJECT_PHOTO, MAX_SUBJECT_PHOTOS: MAX_SUBJECT_PHOTOS, PHOTO_EXT: PHOTO_EXT,
  isSubjectPhoto: isSubjectPhoto, courtDocs: courtDocs, subjectPhotos: subjectPhotos, isPhotoFile: isPhotoFile };
